import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import {
  DELETION_STATUS_COLOR,
  deletionLabel,
  type UserDeletion,
} from "@/lib/account-deletion";

/**
 * A user's open deletion job, as one chip. The label is the state ("Deletion
 * scheduled", "Waiting on a hold", "Running", "Deletion failed: <error>"); the
 * hover says who asked, when, and how many attempts it has taken. A long
 * error is cut by the chip and read in full on hover.
 */
export const DeletionStatus = ({ deletion }: { deletion: UserDeletion }) => {
  const label = deletionLabel(deletion);
  const requested = new Date(deletion.requestedAt);
  const when = Number.isNaN(requested.getTime()) ? deletion.requestedAt : requested.toLocaleString();
  const detail = `${label} · requested by ${deletion.requestedBy === "self" ? "the user" : "an admin"} ${when} · ${
    deletion.attempts
  } attempt${deletion.attempts === 1 ? "" : "s"}`;

  return (
    <Tooltip title={detail}>
      <Chip
        size="small"
        label={label}
        color={DELETION_STATUS_COLOR[deletion.status]}
        variant={deletion.status === "failed" ? "filled" : "outlined"}
        sx={{ maxWidth: "100%" }}
      />
    </Tooltip>
  );
};
